const LOGO_SRC = `${process.env.PUBLIC_URL}/logo-vivo-surgery.png`;

function LegalPageHeader() {
  return (
    <header className="vivo-legal-header">
      <a href="/" aria-label="VIVO SURGERY home">
        <img src={LOGO_SRC} alt="" width={120} height={40} />
      </a>
      <a href="/">Home</a>
    </header>
  );
}

export default LegalPageHeader;
